var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isVolumeMode } from '../Yamaha';
export class Yamaha {
    constructor(log) {
        this.log = log;
        this.deviceInfo = {
            api_version: 2.04,
            category_code: 1,
            destination: 'U',
            device_id: '44FE3B28E950',
            model_name: 'RX-A780',
            netmodule_checksum: 'CFEA3E9D',
            netmodule_generation: 2,
            net_module_num: 1,
            netmodule_version: '0738    ',
            operation_mode: 'normal',
            serial_number: 'Y313479OQ',
            system_id: '0235D183',
            system_version: 1.8,
            update_error_code: '00000000',
        };
        this.features = {
            system: {
                func_list: [
                    'wired_lan',
                    'wireless_lan',
                    'network_standby',
                    'network_standby_auto',
                    'bluetooth_standby',
                    'bluetooth_tx_setting',
                    'bluetooth_tx_connectivity_type',
                    'dfs_option',
                    'headphone',
                    'hdmi_out_1',
                    'hdmi_out_2',
                    'airplay',
                    'disklavier_settings',
                    'background_download',
                    'remote_info',
                    'network_reboot',
                    'system_reboot',
                    'ypao_volume',
                    'party_mode',
                    'party_volume',
                    'party_mute',
                    'name_text_avr',
                    'hdmi_standby_through',
                ],
                zone_num: 2,
                input_list: [
                    {
                        id: 'napster',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'siriusxm',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'pandora',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'spotify',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'qobuz',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'tidal',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'deezer',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'amazon_music',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: true,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'alexa',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'airplay',
                        distribution_enable: false,
                        rename_enable: false,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'mc_link',
                        distribution_enable: false,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'server',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'net_radio',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'bluetooth',
                        distribution_enable: true,
                        rename_enable: false,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'usb',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'netusb',
                    },
                    {
                        id: 'tuner',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'tuner',
                    },
                    {
                        id: 'hdmi1',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'hdmi2',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'hdmi3',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'hdmi4',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'hdmi5',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'av1',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'av2',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'audio1',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'audio2',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'audio3',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'audio4',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'audio5',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'phono',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'aux',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                    {
                        id: 'main_sync',
                        distribution_enable: true,
                        rename_enable: true,
                        account_enable: false,
                        play_info_type: 'none',
                    },
                ],
                bluetooth: { update_cancelable: true },
                web_control_url: '/AdvancedSettings.html?mc=true',
                party_volume_list: ['up', 'down'],
                hdmi_standby_through_list: ['off', 'on', 'auto'],
            },
            zone: [
                {
                    id: 'main',
                    func_list: [
                        'power',
                        'sleep',
                        'volume',
                        'mute',
                        'sound_program',
                        'pure_direct',
                        'enhancer',
                        'tone_control',
                        'dialogue_level',
                        'dialogue_lift',
                        'subwoofer_volume',
                        'signal_info',
                        'prepare_input_change',
                        'link_control',
                        'link_audio_delay',
                        'scene',
                        'contents_display',
                        'cursor',
                        'menu',
                        'actual_volume',
                        'surr_decoder_type',
                        'extra_bass',
                        'adaptive_drc',
                        'dts_dialogue_control',
                        'adaptive_dsp_level',
                    ],
                    input_list: [
                        'napster',
                        'siriusxm',
                        'pandora',
                        'spotify',
                        'qobuz',
                        'tidal',
                        'deezer',
                        'amazon_music',
                        'alexa',
                        'airplay',
                        'mc_link',
                        'server',
                        'net_radio',
                        'bluetooth',
                        'usb',
                        'tuner',
                        'hdmi1',
                        'hdmi2',
                        'hdmi3',
                        'hdmi4',
                        'hdmi5',
                        'av1',
                        'av2',
                        'audio1',
                        'audio2',
                        'audio3',
                        'audio4',
                        'audio5',
                        'phono',
                        'aux',
                    ],
                    sound_program_list: [
                        'munich',
                        'vienna',
                        'chamber',
                        'cellar_club',
                        'roxy_theatre',
                        'bottom_line',
                        'sports',
                        'action_game',
                        'roleplaying_game',
                        'music_video',
                        'standard',
                        'spectacle',
                        'sci-fi',
                        'adventure',
                        'drama',
                        'mono_movie',
                        '2ch_stereo',
                        '7ch_stereo',
                        'surr_decoder',
                        'straight',
                    ],
                    surr_decoder_type_list: [
                        'toggle',
                        'auto',
                        'dolby_surround',
                        'dts_neural_x',
                        'dts_neo6_cinema',
                        'dts_neo6_music',
                    ],
                    tone_control_mode_list: ['manual'],
                    link_control_list: ['speed', 'standard', 'stability'],
                    link_audio_delay_list: ['audio_sync', 'balanced', 'lip_sync'],
                    range_step: [
                        {
                            id: 'volume',
                            min: 0,
                            max: 161,
                            step: 1,
                        },
                        {
                            id: 'tone_control',
                            min: -12,
                            max: 12,
                            step: 1,
                        },
                        {
                            id: 'dialogue_level',
                            min: 0,
                            max: 3,
                            step: 1,
                        },
                        {
                            id: 'dialogue_lift',
                            min: 0,
                            max: 5,
                            step: 1,
                        },
                        {
                            id: 'subwoofer_volume',
                            min: -12,
                            max: 12,
                            step: 1,
                        },
                        {
                            id: 'actual_volume_db',
                            min: -80.5,
                            max: 16.5,
                            step: 0.5,
                        },
                        {
                            id: 'actual_volume_numeric',
                            min: 0,
                            max: 97,
                            step: 0.5,
                        },
                        {
                            id: 'dts_dialogue_control',
                            min: 0,
                            max: 6,
                            step: 1,
                        },
                    ],
                    scene_num: 8,
                    cursor_list: ['up', 'down', 'left', 'right', 'select', 'return'],
                    menu_list: [
                        'on_screen',
                        'top_menu',
                        'menu',
                        'option',
                        'display',
                        'help',
                        'home',
                        'mode',
                        'red',
                        'green',
                        'yellow',
                        'blue',
                    ],
                    actual_volume_mode_list: ['db', 'numeric'],
                    ccs_supported: ['connected_speaker'],
                },
                {
                    id: 'zone2',
                    zone_b: false,
                    func_list: [
                        'power',
                        'sleep',
                        'volume',
                        'mute',
                        'enhancer',
                        'tone_control',
                        'balance',
                        'prepare_input_change',
                        'link_control',
                        'scene',
                        'actual_volume',
                        'extra_bass',
                        'mono',
                    ],
                    input_list: [
                        'napster',
                        'siriusxm',
                        'pandora',
                        'spotify',
                        'qobuz',
                        'tidal',
                        'deezer',
                        'amazon_music',
                        'alexa',
                        'airplay',
                        'mc_link',
                        'server',
                        'net_radio',
                        'bluetooth',
                        'usb',
                        'tuner',
                        'av1',
                        'av2',
                        'audio1',
                        'audio2',
                        'audio3',
                        'audio4',
                        'audio5',
                        'phono',
                        'aux',
                        'main_sync',
                    ],
                    tone_control_mode_list: ['manual', 'auto', 'bypass'],
                    link_control_list: ['speed', 'standard', 'stability'],
                    range_step: [
                        {
                            id: 'volume',
                            min: 0,
                            max: 161,
                            step: 1,
                        },
                        {
                            id: 'tone_control',
                            min: -12,
                            max: 12,
                            step: 1,
                        },
                        {
                            id: 'balance',
                            min: -20,
                            max: 20,
                            step: 1,
                        },
                        {
                            id: 'actual_volume_db',
                            min: -80.5,
                            max: 10,
                            step: 0.5,
                        },
                        {
                            id: 'actual_volume_numeric',
                            min: 0,
                            max: 90.5,
                            step: 0.5,
                        },
                    ],
                    scene_num: 8,
                    actual_volume_mode_list: ['db', 'numeric'],
                },
            ],
            tuner: {
                func_list: ['am', 'fm'],
                range_step: [
                    {
                        id: 'am',
                        min: 530,
                        max: 1710,
                        step: 10,
                    },
                    {
                        id: 'fm',
                        min: 87500,
                        max: 107900,
                        step: 200,
                    },
                ],
                preset: { type: 'common', num: 40 },
            },
            netusb: {
                func_list: ['recent_info', 'play_queue', 'mc_playlist', 'streaming_service_use'],
                preset: { num: 40 },
                recent_info: { num: 40 },
                play_queue: { size: 200 },
                mc_playlist: { size: 200, num: 5 },
                net_radio_type: 'airable',
                pandora: { sort_option_list: ['recent', 'alphabet'] },
            },
            distribution: {
                version: 2,
                compatible_client: [2],
                client_max: 19,
                server_zone_list: ['main', 'zone2'],
                mc_surround: {
                    version: 1,
                    func_list: [],
                    master_role: {
                        surround_pair: true,
                        stereo_pair: false,
                        subwoofer_pair: true,
                    },
                    slave_role: {
                        surround_pair_l_or_r: false,
                        surround_pair_lr: false,
                        subwoofer_pair: false,
                    },
                },
            },
            ccs: {
                supported: true,
            },
        };
        this.status = {
            main: {
                adaptive_drc: false,
                adaptive_dsp_level: false,
                actual_volume: {
                    mode: 'db',
                    value: 0,
                    unit: 'dB',
                },
                contents_display: false,
                dialogue_level: 0,
                dialogue_lift: 0,
                disable_flags: 0,
                distribution_enable: true,
                dts_dialogue_control: 0,
                enhancer: true,
                extra_bass: false,
                input: 'hdmi1',
                input_text: 'Panasonic BD',
                link_audio_delay: 'balanced',
                link_control: 'standard',
                max_volume: 161,
                mute: false,
                party_enable: false,
                power: 'standby',
                pure_direct: false,
                sleep: 0,
                sound_program: 'straight',
                subwoofer_volume: 2,
                surr_decoder_type: 'auto',
                tone_control: {
                    mode: 'manual',
                    bass: 0,
                    treble: 1,
                },
                volume: 161,
            },
        };
        this.asyncHandlers = [
            {
                name: 'getDeviceInfo',
                path: '/YamahaExtendedControl/v1/system/getDeviceInfo',
                callback: (req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: Object.assign(Object.assign({}, this.deviceInfo), { response_code: 0 }) };
                }),
            },
            {
                name: 'getFeatures',
                path: '/YamahaExtendedControl/v1/system/getFeatures',
                callback: (req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: Object.assign(Object.assign({}, this.features), { response_code: 0 }) };
                }),
            },
            {
                name: 'getStatus',
                path: /^\/YamahaExtendedControl\/v1\/([^\/]+)\/getStatus$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const receiverZone = match[1];
                    if (!(receiverZone in this.status))
                        return { data: { response_code: 3 } };
                    return { data: Object.assign(Object.assign({}, this.status[receiverZone]), { response_code: 0 }) };
                }),
            },
            {
                name: 'setActualVolume',
                path: /^\/YamahaExtendedControl\/v1\/([^\/]+)\/setActualVolume$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const receiverZone = match[1];
                    if (!(receiverZone in this.status)) {
                        return { data: { response_code: 3 } };
                    }
                    const mode = (_a = req.params) === null || _a === void 0 ? void 0 : _a.mode;
                    const value = (_b = req.params) === null || _b === void 0 ? void 0 : _b.value;
                    if (mode !== undefined) {
                        if (!isVolumeMode(mode)) {
                            return { data: { response_code: 4 } };
                        }
                        this.status[receiverZone].actual_volume.mode = mode;
                    }
                    if (value !== undefined) {
                        const volumeDb = parseInt(value, 10);
                        this.status[receiverZone].actual_volume.value = volumeDb;
                        this.status[receiverZone].volume = this.convertVolumeFromDb(volumeDb);
                    }
                    return { data: { response_code: 0 } };
                }),
            },
            {
                name: 'setInput',
                path: /^\/YamahaExtendedControl\/v1\/([^\/]+)\/setInput$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _c;
                    const receiverZone = match[1];
                    const input = (_c = req.params) === null || _c === void 0 ? void 0 : _c.input;
                    if (!(receiverZone in this.status))
                        return { data: { response_code: 3 } };
                    if (input === undefined || !this.validInputs.includes(input)) {
                        return { data: { response_code: 4 } };
                    }
                    this.status[receiverZone].input = input;
                    return { data: { response_code: 0 } };
                }),
            },
            {
                name: 'setMute',
                path: /^\/YamahaExtendedControl\/v1\/([^\/]+)\/setMute$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _d;
                    const receiverZone = match[1];
                    if (!(receiverZone in this.status))
                        return { data: { response_code: 3 } };
                    if (((_d = req.params) === null || _d === void 0 ? void 0 : _d.enable) === undefined)
                        return { data: { response_code: 4 } };
                    this.status[receiverZone].mute = req.params.enable === 'true';
                    return { data: { response_code: 0 } };
                }),
            },
            {
                name: 'setPower',
                path: /^\/YamahaExtendedControl\/v1\/([^\/]+)\/setPower$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _e;
                    const receiverZone = match[1];
                    if (!(receiverZone in this.status))
                        return { data: { response_code: 3 } };
                    if (((_e = req.params) === null || _e === void 0 ? void 0 : _e.power) === undefined)
                        return { data: { response_code: 4 } };
                    this.status[receiverZone].power = req.params.power === 'on' ? 'on' : 'standby';
                    return { data: { response_code: 0 } };
                }),
            },
            {
                name: 'invalidEndpoint',
                path: /^\/YamahaExtendedControl\/v1/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: { response_code: 3 } };
                }),
            },
            {
                name: 'invalidRoot',
                path: /./,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { error: '', status: 404 };
                }),
            },
        ];
        this.validInputs = this.features.zone[0].input_list;
        for (const zone of this.features.zone) {
            if (zone.id === 'main') {
                this.validInputs = zone.input_list;
                break;
            }
        }
        if (this.validInputs === undefined) {
            this.log.error('could not find main zone in features');
        }
    }
    convertVolumeFromDb(volumeDb) {
        const [xMax, xMin] = [0, -43.5];
        const [yMax, yMin] = [161, 74];
        const slope = (yMax - yMin) / (xMax - xMin);
        const offset = yMax - slope * xMax;
        let volume = Math.round(slope * volumeDb - offset);
        if (volume > yMax)
            volume = yMax;
        if (volume < yMin)
            volume = yMin;
        return volume;
    }
}
Yamaha.emulatorType = 'httpRequestEmulator';
Yamaha.key = '-M4F1s68VxDuXE3P4Cat';
